var _line, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartD(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 68,
    viewBox: "0 0 64 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.548825,
    y1: 42.0527,
    x2: 63.4512,
    y2: 42.0527,
    stroke: "#828282",
    strokeWidth: 1.09765,
    strokeLinecap: "round",
    strokeDasharray: "2.2 2.2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.71 41.7717C14.3766 29.6178 15.9766 5.16965 17.0433 4.6087C17.71 2.73886 19.4433 0.121093 21.0433 4.6087C21.71 9.51704 23.1766 23.8213 23.71 41.7717C23.71 49.9522 24.11 66.173 25.71 65.612C25.9322 66.547 27.31 66.8742 31.0433 60.7037C31.71 60.0025 33.4433 60.0025 35.0433 65.612C35.71 65.8458 37.1766 64.4901 37.71 57.1978C38.1544 51.3545 39.4433 39.6681 41.0433 39.6681C41.9322 38.7331 44.11 37.9852 45.71 42.4728C46.5989 43.8752 49.4433 45.8385 53.71 42.4728",
    stroke: "#66FCF1",
    strokeWidth: 2.42456,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartD);
export default __webpack_public_path__ + "static/media/chartD.9bb6363567c18cd1f34fcc34a00a1982.svg";
export { ForwardRef as ReactComponent };